import React from 'react';
//@ts-ignore
import * as cardStyles from './cards.module.css';
import { RelatedProductsProps } from './index';
import ProductTile from './ProductTile';
import { ProductPagePreview } from '../Global/DataUtils/productQueries';
import { getColor } from '../Global/DataUtils';

interface Props extends RelatedProductsProps {
    selectedProducts: ProductPagePreview[];
    productCtaLabel?: string;
}

const Cards: React.FC<Props> = ({
    selectedProducts,
    background_color,
    content_panel__content_panel_color,
    content_panel__content_panel_font_color,
    ...props
}) => {
    if (selectedProducts?.length === 0) return null;

    return (
        <div className={cardStyles.cardsContainer}>
            {selectedProducts?.map((product, idx) => {
                const productStyle =
                    (selectedProducts?.length % 2 === 1 &&
                        (idx + 1) % 3 === 0) ||
                    selectedProducts?.length === 1
                        ? `${cardStyles.product} ${cardStyles.wideProduct}`
                        : cardStyles.product;

                return (
                    <ProductTile
                        key={idx}
                        product={product}
                        productCtaLabel={
                            props.product_cta_label?.value || 'View Product'
                        }
                        backgroundColor={
                            getColor(content_panel__content_panel_color) ||
                            undefined
                        }
                        fontColor={
                            getColor(content_panel__content_panel_font_color) ||
                            undefined
                        }
                        truncateLines={3}
                        productStyle={productStyle}
                        ctaStyle={cardStyles.ctaContainer}
                    />
                );
            })}
        </div>
    );
};

export default Cards;
